export default __webpack_public_path__ + "static/media/biomolecula.c2eec773.svg";